import { AiFillStar } from "react-icons/ai";

const StartIcon = (props) => {
  return <AiFillStar className={props.className} />;
};

export default StartIcon;
